export const enum FilterName {
  Type = 'type',
  Category = 'category',
  Orientation = 'orientation',
  Color = 'color',
  Pricing = 'pricing',
}
